import { Country } from '@freelancer/datastore/countries';
import { Location } from '@freelancer/datastore/project-view-users';
import { CountryApi, LocationApi } from 'api-typings/common/common';

export function transformLocation(location: LocationApi): Location {
  if (!location.country) {
    throw new ReferenceError(`Missing a required location field.`);
  }

  return {
    country: transformCountry(location.country),
    city: location.city,
    mapCoordinates:
      location.latitude !== undefined && location.longitude !== undefined
        ? {
            latitude: location.latitude,
            longitude: location.longitude,
          }
        : undefined,
    vicinity: location.vicinity,
    administrativeArea: location.administrative_area,
    fullAddress: location.full_address,
  };
}

// the countries returned from the Users API can be a little wonky sometimes
// this function is a bit more "safe" than the one in countries.transformers
export function transformCountry(country: CountryApi): Country {
  return {
    id: country.code || '',
    code: country.code || '',
    name: country.name || '',
    flagUrl: country.flag_url,
  };
}
